module.exports = __webpack_public_path__ + "img/4-1.e12fe842.jpg";